module.exports = __webpack_public_path__ + "img/box2.4e4093a6.png";